var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tradingview-chart"},[_c('div',{class:[_vm.getOS == 'ios' ? 'ios' : ''],attrs:{"id":"tradingview_chart_container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }